




























































































import { Component, Vue, Prop, PropSync, Watch } from "vue-property-decorator";
import DxPopup from "devextreme-vue/popup";
import DButton from '@/components/DButton/button.vue';
import { Contractor } from "@/services/models-service";
import _ from "lodash";


@Component({
    name: "ChoiceRecalcPopup",
    components: {
        DxPopup,
        DButton,
    }
    })
    export default class extends Vue {
        @PropSync('popupVisible', { type: Boolean }) popupLocalVisible!: boolean;
        @PropSync('changes') changesArray!: any[];
        @PropSync('changeStatus') changeLocalStatus!: string;
        @PropSync('mainData') mainLocalData!: any;
        @PropSync('count') countChanges!: number;
        @Prop() oldData!: any;
        @Prop() public allContractor!: Contractor[];
        @Prop() public showVolume!: boolean;
        @Prop() public showCost!: boolean;

        private localCountChanges: number = 1;
        private readonly floatingEpsilon: number = 1e-9;

        public monthsNames: any = {
            'january': 'Январь',
            'february': 'Февраль',
            'march': 'Март',
            'april': 'Апрель',
            'may': 'Май',
            'june': 'Июнь',
            'july': 'Июль',
            'august': 'Август',
            'september': 'Сентябрь',
            'october': 'Октябрь',
            'november': 'Ноябрь',
            'december': 'Декабрь',
        }

        get shouldShowBatchButtons(): boolean {
            return this.localCountChanges !== 1;
        }

        get isSingleColumnMassInsert(): boolean {
            if (!this.changesArray || this.changesArray.length === 0) {
                return false;
            }

            // Проверяем, что все изменения изменяют только одну колонку
            // Либо все только volume (без cost), либо все только cost (без volume)
            const allVolumeOnly = this.changesArray.every(change =>
                change && change.volume && !change.cost
            );
            const allCostOnly = this.changesArray.every(change =>
                change && change.cost && !change.volume
            );

            return allVolumeOnly || allCostOnly;
        }

        @Watch('allContractor', { deep: true })
        onAllContractorChanged(newVal: Contractor[]) {
            console.log('allContractor', newVal);
        }

        @Watch('countChanges', { immediate: true })
        onCountChangesChanged(newVal: number) {
            this.localCountChanges = newVal;
        }

        allButtonsText(): string[] {
            if (!this.changesArray || this.changesArray.length === 0) {
                return ['', '', ''];
            }

            // Если массовая вставка только в одну колонку, определяем какая именно
            if (this.isSingleColumnMassInsert) {
                const allVolumeOnly = this.changesArray.every(change =>
                    change && change.volume && !change.cost
                );
                const allCostOnly = this.changesArray.every(change =>
                    change && change.cost && !change.volume
                );

                if (allVolumeOnly) {
                    // Массовая вставка только в volume - пересчитываем стоимость
                    return [`Применить и пересчитать<br/>стоимость для всех ячеек`, `Применить и не пересчитывать<br/>стоимость для всех ячеек`, `Отменить изменения`];
                } else if (allCostOnly) {
                    // Массовая вставка только в cost - пересчитываем объем
                    return [`Применить и пересчитать<br/>объем для всех ячеек`, `Применить и не пересчитывать<br/>объем для всех ячеек`, `Отменить изменения`];
                }
            }

            // Стандартная логика в зависимости от видимости колонок
            if (this.showVolume && this.showCost) {
                return [`Применить и пересчитать всё`, `Применить и не пересчитывать всё`, `Отменить изменения`];
            } else if (this.showVolume && !this.showCost) {
                return [`Применить и пересчитать<br/>стоимость для всех ячеек`, `Применить и не пересчитывать<br/>стоимость для всех ячеек`, `Отменить изменения`];
            } else if (!this.showVolume && this.showCost) {
                return [`Применить и пересчитать<br/>объем для всех ячеек`, `Применить и не пересчитывать<br/>объем для всех ячеек`, `Отменить изменения`];
            } else {
                return ['', '', ''];
            }
        }

        onShowing() {
            this.localCountChanges = this.countChanges;
        }

        mounted() {
            this.localCountChanges = this.countChanges;
        }

        getRecalcText(change: any): string {
            if (change.te && change.volume){
                const oldCost_te = change.data.cost_te || 0;
                const newCost_te = change.tariff * change.data.vol_te;
                return `Применить <b>Объем тэ = ${change.data.vol_te}</b> и изменить <b>Стоимость тэ (итого)</b> с <b>${oldCost_te}</b> на <b>${newCost_te}</b>`
            }
            if (change.power && change.volume){
                const oldCost_power = change.data.cost_power || 0;
                const newCost_power = change.tariff * change.data.vol_power / 1000;
                return `Применить <b>Объем мощности = ${change.data.vol_power}</b> и изменить <b>Стоимость мощности (итого)</b> с <b>${oldCost_power}</b> на <b>${newCost_power}</b>`
            }
            if (change.te && change.cost){
                const oldVol_te = change.data.vol_te || 0;
                const newVol_te = change.data.cost_te / change.tariff;
                return `Применить <b>Стоимость тэ (итого) = ${change.data.cost_te}</b> и изменить <b>Объем тэ</b> с <b>${oldVol_te}</b> на <b>${newVol_te}</b>`
            }
            if (change.power && change.cost){
                const oldVol_te = change.data.vol_power || 0;
                const newVol_te = change.data.cost_power * 1000 / change.tariff;
                return `Применить <b>Стоимость мощности (итого) = ${change.data.cost_power}</b> и изменить <b>Объем мощности</b> с <b>${oldVol_te}</b> на <b>${newVol_te}</b>`
            }
            return '';
        }

        getNotRecalcText(change: any): string {
            if (change.te && change.volume) {
                const delta = (change.data.vol_te * change.tariff) - change.data.cost_te;
                return `Применить <b>Объем тэ = ${change.data.vol_te}</b> и изменить <b>Стоимость тэ (корректировка) с ${change.data.cost_delta_te} на ${delta}</b>`
            }
            if (change.power && change.volume) {
                const delta = (change.data.vol_power * change.tariff / 1000) - change.data.cost_power;
                return `Применить <b>Объем мощности = ${change.data.vol_power}</b> и изменить <b>Стоимость мощности (корректировка) с ${change.data.cost_delta_power} на ${delta}</b>`
            }
            if (change.te && change.cost) {
                const delta =  (change.data.vol_te * change.tariff) - change.data.cost_te;
                return `Применить <b>Стоимость тэ (итого) = ${change.data.cost_te}</b> и изменить <b>Стоимость тэ (корректировка) с ${change.data.cost_delta_te} на ${delta}</b>`
            }
            if (change.power && change.cost) {
                const delta = (change.data.vol_power * change.tariff / 1000) - change.data.cost_power;
                return `Применить <b>Стоимость мощности (итого) = ${change.data.cost_power}</b> и изменить <b>Стоимость мощности (корректировка) с ${change.data.cost_delta_te} на ${delta}</b>`
            }

            return '';
        }
        private findRowByData(list: any[] | undefined, data: any, allowReference = false): any | null {
            if (!list || !data) {
                return null;
            }

            if (allowReference) {
                const byRef = list.find((item: any) => item === data);
                if (byRef) {
                    return byRef;
                }
            }

            if (data.id != null) {
                return list.find((item: any) => item.id === data.id) || null;
            }

            if (data.contractor_instance_id && data.tariff_instance_id) {
                const byInstance = list.find((item: any) =>
                    item.contractor_instance_id === data.contractor_instance_id &&
                    item.tariff_instance_id === data.tariff_instance_id
                );
                if (byInstance) {
                    return byInstance;
                }
            }

            if (data.id_contractor && data.id_tarif) {
                const byContractorTariff = list.find((item: any) =>
                    item.id_contractor === data.id_contractor &&
                    item.id_tarif === data.id_tarif
                );
                if (byContractorTariff) {
                    return byContractorTariff;
                }
            }

            return null;
        }

        private normalizeDelta(value: number): number {
            return Math.abs(value) < this.floatingEpsilon ? 0 : value;
        }

        updateOldData(block: string, month: string, id: any, data?: any) {
            const mainList = this.mainLocalData[block]?.[month] as any[] | undefined;
            const mainDataBlock = this.findRowByData(mainList, data || { id }, true);
            if (mainDataBlock) {
                if (!this.oldData[block]) {
                    this.oldData[block] = {};
                }
                if (!this.oldData[block][month]) {
                    this.oldData[block][month] = [];
                }
                const oldList = this.oldData[block][month] as any[];
                let oldDataBlock = this.findRowByData(oldList, mainDataBlock);
                if (oldDataBlock) {
                    Object.assign(oldDataBlock, _.cloneDeep(mainDataBlock));
                } else {
                    this.oldData[block][month].push(_.cloneDeep(mainDataBlock));
                }
            }
        }

        recalcOnce(index: number) {
            const change = this.changesArray[index]
            if (!change || !change.data || !change.data.block) {
                console.error('Invalid change object:', change);
                return;
            }
            console.log('change', change);
            const mainList = this.mainLocalData[change.data.block]?.[change.data.month] as any[] | undefined;
            const mainDataBlock = this.findRowByData(mainList, change.data, true);
            if (!mainDataBlock) {
                console.error('Main data row not found for change:', change);
                return;
            }
            if (change.te && change.volume){
                mainDataBlock.cost_te = change.tariff * change.data.vol_te;
                mainDataBlock.cost_delta_te = 0;
                mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                this.updateOldData(change.data.block, change.data.month, change.data.id, change.data);
                this.changesArray.splice(index,1)
                this.countChanges--
                this.localCountChanges = this.countChanges;
                if(this.countChanges===0){
                    this.onClose()
                }
            }
            if (change.power && change.volume){
                mainDataBlock.cost_power = change.tariff * change.data.vol_power / 1000;
                mainDataBlock.cost_delta_power = 0;
                mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                this.updateOldData(change.data.block, change.data.month, change.data.id, change.data);
                this.changesArray.splice(index,1)
                this.countChanges--
                this.localCountChanges = this.countChanges;
                if(this.countChanges===0){
                    this.onClose()
                }
            }
            if (change.te && change.cost){
                mainDataBlock.vol_te = change.data.cost_te / change.tariff;
                mainDataBlock.cost_delta_te = 0;
                mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                this.updateOldData(change.data.block, change.data.month, change.data.id, change.data);
                this.changesArray.splice(index,1)
                this.countChanges--
                this.localCountChanges = this.countChanges;
                if(this.countChanges===0){
                    this.onClose()
                }
            }
            if (change.power && change.cost){
                mainDataBlock.vol_power = change.data.cost_power * 1000 / change.tariff;
                mainDataBlock.cost_delta_power = 0;
                mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                this.updateOldData(change.data.block, change.data.month, change.data.id, change.data);
                this.changesArray.splice(index,1)
                this.countChanges--
                this.localCountChanges = this.countChanges;
                if(this.countChanges===0){
                    this.onClose()
                }
            }
        }
        notRecalcOnce(index: number) {
            const change = this.changesArray[index]
            if (!change || !change.data || !change.data.block) {
                console.error('Invalid change object:', change);
                return;
            }
            const mainList = this.mainLocalData[change.data.block]?.[change.data.month] as any[] | undefined;
            const mainDataBlock = this.findRowByData(mainList, change.data, true);
            if (!mainDataBlock) {
                console.error('Main data row not found for change:', change);
                return;
            }
            if (change.te && change.volume){
                mainDataBlock.cost_delta_te = (change.data.vol_te * change.tariff) - change.data.cost_te;
                mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                this.updateOldData(change.data.block, change.data.month, change.data.id, change.data);
                this.changesArray.splice(index,1)
                this.countChanges--
                this.localCountChanges = this.countChanges;
                if(this.countChanges===0){
                    this.onClose()
                }
            }
            if (change.power && change.volume){
                mainDataBlock.cost_delta_power = (change.data.vol_power * change.tariff / 1000) - change.data.cost_power;
                mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                this.updateOldData(change.data.block, change.data.month, change.data.id, change.data);
                this.changesArray.splice(index,1)
                this.countChanges--
                this.localCountChanges = this.countChanges;
                if(this.countChanges===0){
                    this.onClose()
                }
            }
            if (change.te && change.cost){
                const delta = (change.data.vol_te * change.tariff) - change.data.cost_te;
                mainDataBlock.cost_delta_te = this.normalizeDelta(delta);
                mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                this.updateOldData(change.data.block, change.data.month, change.data.id, change.data);
                this.changesArray.splice(index,1)
                this.countChanges--
                this.localCountChanges = this.countChanges;
                if(this.countChanges===0){
                    this.onClose()
                }
            }
            if (change.power && change.cost){
                const delta = (change.data.vol_power * change.tariff / 1000) - change.data.cost_power;
                mainDataBlock.cost_delta_power = this.normalizeDelta(delta);
                mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                this.updateOldData(change.data.block, change.data.month, change.data.id, change.data);
                this.changesArray.splice(index,1)
                this.countChanges--
                this.localCountChanges = this.countChanges;
                if(this.countChanges===0){
                    this.onClose()
                }
            }
        }
        cancelOnce(index: number) {
            const change = this.changesArray[index]
            if (!change || !change.data || !change.data.block) {
                console.error('Invalid change object:', change);
                return;
            }
            const mainList = this.mainLocalData[change.data.block]?.[change.data.month] as any[] | undefined;
            const mainDataBlock = this.findRowByData(mainList, change.data, true);
            const oldList = this.oldData[change.data.block]?.[change.data.month] as any[] | undefined;
            const oldDataBlock = this.findRowByData(oldList, change.data);

            if (oldDataBlock) {
                // Восстанавливаем все поля из oldData
                const currentOrder = mainDataBlock.c_order;
                Object.assign(mainDataBlock, _.cloneDeep(oldDataBlock));
                if (currentOrder !== undefined) {
                    mainDataBlock.c_order = currentOrder;
                }
            } else {
                // Если oldDataBlock не найден, восстанавливаем только измененное поле из change.data
                if (this.changesArray[index].te && this.changesArray[index].volume){
                    mainDataBlock.vol_te = change.data.vol_te
                    mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                }
                else if (this.changesArray[index].power && this.changesArray[index].volume){
                    mainDataBlock.vol_power = change.data.vol_power
                    mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                }
                else if (this.changesArray[index].te && this.changesArray[index].cost){
                    mainDataBlock.cost_te = change.data.cost_te
                    mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                }
                else if (this.changesArray[index].power && this.changesArray[index].cost){
                    mainDataBlock.cost_power = change.data.cost_power
                    mainDataBlock.cost_total = mainDataBlock.cost_te + mainDataBlock.cost_power;
                }
            }

            this.changesArray.splice(index,1)
            this.countChanges--
            this.localCountChanges = this.countChanges;
            if(this.countChanges===0){
                this.onClose()
            }
        }
        recalcAll() {
            const count = _.cloneDeep(this.countChanges)
            for (let i = 0; i < count && this.changesArray.length > 0; i++) {
                this.recalcOnce(0);
            }
            this.$nextTick(() =>{
                this.onClose()
            })
        }
        notRecalcAll() {
            const count = _.cloneDeep(this.countChanges)
            for (let i = 0; i < count && this.changesArray.length > 0; i++) {
                this.notRecalcOnce(0);
            }
            this.$nextTick(() =>{
                this.onClose()
            })
        }
        cancelAll() {
            const count = _.cloneDeep(this.countChanges)
            for (let i = 0; i < count && this.changesArray.length > 0; i++) {
                this.cancelOnce(0);
            }
            this.$nextTick(() =>{
                this.onClose()
            })
        }

        onClose() {
            this.changesArray = []
            this.countChanges = 1
            this.localCountChanges = 1
            this.$emit('onClose')
        }
    }
